import produce from "immer";
import { uuid } from "uuidv4";
import { Form } from "../models/formModel";
import { ADD_FORM, EDIT_FORM, FormActionTypes, REMOVE_ALL_FORMS, REMOVE_FORM, SET_FORM } from "../types/actions";

// const formReducerDefaultState: Form[] =  [{id:uuid(), name:'New Form'}]; 
const formReducerDefaultState: Form[] =  []; 

const formReducer = (state : Form[] = formReducerDefaultState, action : FormActionTypes) : Form[] => {
    switch (action.type) {
        case ADD_FORM:
            return produce(state, draft => {draft.push(action.form)});
        case REMOVE_FORM:
            return produce(state, draft => { draft.splice(draft.findIndex(form => form.id === action.id), 1);});
        case SET_FORM:
            return action.forms;
        case EDIT_FORM:
            return produce(state, draft => {  draft[draft.findIndex(form => form.id === action.form.id)] = action.form;});
        case REMOVE_ALL_FORMS:
            return produce(state, draft => {return draft = []});
        default:
            return state;
    }
}

export default formReducer
